var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBroadcast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9998,
    cy: 18,
    r: 17.5271,
    fill: "#37C2D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8267 22.2251L25.6097 17.4649C26.2812 17.0754 26.7428 16.3397 26.7428 15.4743C26.7428 14.2193 25.7356 13.1807 24.5186 13.1807L23.3016 8.42052C23.1337 7.81468 22.3783 7.64158 22.0006 8.16088C21.2452 9.15619 20.3219 10.2813 19.1049 11.3199C16.2092 13.8731 13.2296 14.9982 11.2572 15.5175C10.5857 15.6906 9.95625 16.0368 9.45265 16.5561C8.65529 17.4216 8.27759 18.6333 8.44546 19.8017C8.52939 20.4508 8.78119 21.0134 9.15889 21.5327C10.0402 22.7444 11.5929 23.2204 13.0198 22.8742L13.9431 25.6437C14.1109 26.163 14.6565 26.4227 15.1181 26.2496L16.503 25.7736C17.0066 25.6005 17.2584 25.0379 17.0905 24.5619L16.2512 21.9654C17.804 21.6625 19.6085 21.5327 21.6649 21.8789C23.3016 22.1385 24.7284 22.6145 25.8195 23.1338C26.4071 23.3502 26.9946 22.8309 26.8267 22.2251Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBroadcast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/broadcast.d7dd227206bff70ab2f38238370da642.svg";